<template>
  <div style="background: #f9f9f9">
    <!--    <img src="./model.svg" alt="" style="width: 100%;">-->
    <div class="printBanner">
      <el-carousel
        indicator-position="none"
        :interval="5000"
        :height="imgHeight + 'px'"
        style="background-color: #f0f0f0"
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
                <img :src="item.value" alt="" style="width: 100%" ref="image"/>
            </a>
            <a v-else href="javascript:void(0)">
                <img :src="item.value" alt="" style="width: 100%" ref="image"/>
            </a>
          <!--<div class="printBanBox">
                                <h2>3D模型库</h2>
                                <div class="printBanText">
                                  <p>
                                    3D打印工业互联网平台提供设计供需对接服务，实现在线定制化有创意、性价比高、体验好的产品模型设计，让创意与想象力摆脱束缚，轻松制造出个性化的产品。
                                  </p>
                                </div>
                              </div>-->
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="print_screen">
      <div class="print_screen_box flex" style="position: relative">
        <!-- <div class="uploadModelButton">上传模型</div> -->
        <p class="print_title">分类：</p>
        <div>
          <div class="print_screen_boxP">
            <p
              v-for="(items, index) in screenList"
              :key="index"
              @click="getPrintScreen(index, items.name)"
              :class="printScreenIndex == index ? 'screen_text' : ''"
            >
              {{ items.name }}
            </p>
            <!-- <p
              @click="getPrintScreen(index, items.name)"
              :class="printScreenIndex == index ? 'screen_text' : ''"
            >
              {{ items.name }}
            </p> -->
          </div>
          <div
            class="flex"
            style="padding: 15px 15px 5px; background: rgb(241, 245, 254)"
            v-show="screenList[printScreenIndex].name == '全部'? classShow= false:classShow= true"
          >
            <p
              v-for="(items, index) in screenList2"
              :key="index"
              :class="printScreenTwoIndex == index ? 'materDetailsT' : ''"
              @click="getPrintScreenTwo(index)"
              style="cursor: pointer"
            >
              {{ items.name }}
            </p>
          </div>
        </div>
      </div>
      <!-- 内容 -->

      <!-- 筛选 -->
      <div class="flex print_screen_box print_shai">
        <p>筛选：</p>
        <p
          :class="printNews2 == items.value ? 'print_newsPs' : 'print_newsP'"
          v-for="(items, index) in printNewss2"
          :key="index"
          @click="getPrintNews2(items.value)"
        >
          {{ items.name }}
        </p>
      </div>
    </div>
    <div class="print_news flex">
      <div class="flex print_news1">
        <!-- <p>排序：</p> -->
        <!-- <p style="cursor: pointer"
                           :class="printNews == -1 ? 'print_sort' : ''"
                           @click="getPrintNews(-1)" :key="-1"
                        >
                            默认
                        </p> -->
        <p
          style="cursor: pointer"
          :class="printNews == items.value ? 'print_sort' : 'print_sort2'"
          v-for="(items, index) in printNewss"
          :key="index"
          @click="getPrintNews(items.value)"
        >
          {{ items.title }}
          <!-- <i class="el-icon-bottom"></i> -->
          <i class="el-icon-bottom" v-if="items.value=='NEW'&& getPrintNews1==0"></i>
          <i class="el-icon-top" v-if="items.value=='NEW'&& getPrintNews1==1"></i>
          <i class="el-icon-bottom" v-if="items.value=='HOT'&& getPrintNews6==0"></i>
          <i class="el-icon-top" v-if="items.value=='HOT'&& getPrintNews6==1"></i>
          <i class="el-icon-bottom" v-if="items.value=='COLLECTION'&& getPrintNews3==0"></i>
          <i class="el-icon-top" v-if="items.value=='COLLECTION'&& getPrintNews3==1"></i>
          <i class="el-icon-bottom" v-if="items.value=='LIKE'&& getPrintNews4==0"></i>
          <i class="el-icon-top" v-if="items.value=='LIKE'&& getPrintNews4==1"></i>
          <i class="el-icon-bottom" v-if="items.value=='DOWNLOAD'&& getPrintNews5==0"></i>
          <i class="el-icon-top" v-if="items.value=='DOWNLOAD'&& getPrintNews5==1"></i>
        </p>
      </div>
      <div class="print_input">
        <el-button size="small" type="primary" @click="getUsercenter('designer')" v-if="designer" ><i class="el-icon-plus"></i>上传模型</el-button>
        <input
          v-model="modelName"
          @input="searchList"
          type="text"
          placeholder="请输入"
        />
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="container">
      <div v-if="showNoModel" style="text-align:center;margin-bottom:20px" >
          <img src="../../assets/暂无搜索内容.jpg" alt="" style="width:200px">
      </div>
      <section style="padding-bottom: 30px" v-else>
        <!-- <div style="height: 120px; margin-bottom: 30px"></div> -->
        <el-row :gutter="30" class="content" style="margin: 0">
          <waterfall
            :col="5"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
            :data="modelList"
            @loadmore="loadMore"
            :loadDistance="100"
          >
            <div v-for="(items, index) in modelList" :key="index">
              <el-card
                class="box-card"
                shadow="always"
                :body-style="{ padding: '0px' }"
              >
                <el-image
                  class="image"
                  :src="items.imgUrl"
                  fit="cover" style="cursor: pointer" @click="getModelDetalis(index)"
                ></el-image>
                <el-tag class="mdfree" effect="plain">
                  {{ items.attributeCn }}
                </el-tag>
                <div
                  style="padding: 15px; cursor: pointer"
                >
                  <h4 class="mdTitle" @click="getModelDetalis(index)">
                    {{ items.modelName|ellipsis
                    }}<span class="mdTime" >{{ items.time }}</span>
                  </h4>
                  <p class="mdDetail" @click="getModelDetalis(index)">{{ items.typeFirstName }}-{{ items.typeSecondName }}</p>
                  <div class="mpNum">
                    <span
                      ><a
                        ><i class="el-icon-view" style="margin-right: 8px"></i
                        >{{ items.accessNum }}</a
                      ></span
                    >
                    <span v-if="!items.hasLiked"
                      ><a href="javascript:void(0)"
                        ><i
                          class="el-icon-star-off"
                          style="margin-right: 8px"
                        ></i
                        >{{ items.collectionNum }}</a
                      ></span
                    >
                    <span v-if="items.hasLiked"
                      ><a href="javascript:void(0)"
                        ><i
                          class="el-icon-star-on"
                          style="margin-right: 8px"
                        ></i
                        >{{ items.collectionNum }}</a
                      ></span
                    >
                    <span
                      ><a href="javascript:void(0)"
                        ><i
                          class="el-icon-chat-dot-square"
                          style="margin-right: 8px"
                        ></i
                        >{{ items.commentsNum }}</a
                      ></span
                    >
                  </div>
                  <div class="mpFooter" @click="getDesigner(items.creatorUuid)">
                    <div >
                      <el-avatar
                        size="medium"
                        :src="items.designerHead=== null?require('../../assets/headportrait.png'):items.designerHead"
                      ></el-avatar>
                    </div>
                    <span style="flex: 1; margin-left: 8px; font-size: 12px">{{
                      items.designerName
                    }}</span>
                    <div>
                      <el-button @click="getModelDetalis(index)">
                        <i class="el-icon-download el-icon--right"></i>
                        {{ items.downNum }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </waterfall>
        </el-row>
        <!-- <div style="text-align: right">
                            <el-pagination
                                style="margin-right: -10px"
                                background
                                layout="prev, pager, next"
                                :total="50"
                            >
                            </el-pagination>
                        </div>-->
      </section>
          <div style="text-align: right; padding: 0 0px 30px">
      <el-pagination
              background
              @current-change="handleCurrentChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="current"
              :page-size="pageSize"
              :total="total" class="pagination">
      </el-pagination>
    </div>
    </div>

  </div>
</template>

<script>
import {
  getParkAddrList,
  getBannerList,
  designerByUserId,
  getModelList,
  getDictionaryGroup,
  getDictionaryItem,
  like,
  saveModelCollection,
  queryModelList, getNewcurrent,
} from "../../utils/interface";

import { mapState, mapMutations } from "vuex";
import { getHumanDate } from "../../utils/date";
export default {
  //   模型库
  name: "model",
  metaInfo: {
    title: '3D模型库|3D打印模型交易平台——增材云3D模型库|原创3D模型下载', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '3D模型库|3D模型下载|3D打印模型下载|手办3D模型|游戏人物3D模型|玩具3D模型|家居摆件模型|艺术摆件模型'
    },
      {                 // set meta
        name: 'description',
        content: '增材云3D模型库是国内原创3D打印模型交易平台，手办玩具、家居用品、艺术摆件、教育工具、科技配件、微型景观，各类3D模型应有尽有。增材云，聚合3D打印设计师、3D打印厂商、3D打印原料、3D打印模型、3D打印软件及课程等6大资源。'
      }
    ],
  },
  data() {
    return {
      getPrintNews1:0,
      getPrintNews6:0,
      getPrintNews3:0,
      getPrintNews4:0,
      getPrintNews5:0,
      showNoModel:false,
      setIn: null,
      modelName: "",
      imgHeight: "",
      imgHeightsetIn: null,
      groupCode: "model_banner",
      // groupCode: "SOLUTION_BANNER", // 类别
      bannerList: [],
      modelList: [],
      // 模型的筛选部分
      screenList: [
        {
          uuid: "",
          name: "全部",
        },
      ],
      screenList2: [
        {
          uuid: "",
          name: "全部",
        },
      ],
      printNewss: [
        {
          value: "NEW",
          title: "最新",
        },
        {
          value: "HOT",
          title: "最热",
        },
        {
          value: "COLLECTION",
          title: "收藏",
        },
        {
          value: "LIKE",
          title: "点赞",
        },
        {
          value: "DOWNLOAD",
          title: "下载",
        },
      ],
      printNewss2: [
        {
          value: "",
          name: "全部",
        },
        {
          name: "免费模型",
          value: "FREE",
        },
        {
          name: "收费模型",
          value: "PAY",
        },
        {
          name: "仅预览",
          value: "BROWSE",
        },
      ],
      printScreenIndex: "0",
      printScreenTwoIndex: "0",
      printNews: "",
      order: "DESC",
      printNews2: "",
      classShow: false,
      // 分页
      current: 1,
      total: 0,
      pageSize: 15,
      timeOut:null,
      designer:false,
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
        isLogin: "isLogin",
        isUsermessage: "isUsermessage"
    }),
    itemWidth() {
      return 224;
      //rem布局 计算列宽度
      //可以根据自己的rem设置修改这里的 334 值
    },
    gutterWidth() {
      return 20;

      //rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)

      //可以根据自己的rem设置修改这里的 36 值
    },
  },

  created() {
    this.getBannerList();
    this.getGroup();
    this.getModelList();
    this.getUserMessage();
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 8) {
        return value.slice(0,8) + '...'
      }
      return value
    }
  },

  mounted() {
      window.addEventListener("resize", () => {
        if (this.$refs.image[0].height) {
          this.imgHeight = this.$refs.image[0].height;
        }
      });
  },

  methods: {
    getUserMessage() {
      getNewcurrent()
          .then((res) => {
            console.log("getNewcurrent",res);
            if (res.authorities.length !== 0) {
              res.authorities.forEach(items => {
                if (items == 'designerCenterService') {
                  this.designer = true
                }
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    searchList(){
      if(this.timeOut!=null ){
        clearTimeout(this.timeOut);
        this.timeOut = null;
      }
      this.timeOut = setTimeout(() => {
        clearTimeout(this.timeOut);
        this.getModelList();
      }, 1000);
    },
    getUsercenter(user) {
      if (user == "designer") {
        let routeData = this.$url.designerWeb +"/#/modelManagement";
        window.open(routeData, "_blank");
        this.$cookies.set("authoritiesMess", 'designerCenterService');
      }
    },
    // 分页
    handleCurrentChange(val){
      this.current = val;
	  window.scrollTo(0,0);
      console.log('modelList',this.modelList );

      this.getModelList();
    },
    getDesigner(uuid) {
      designerByUserId(uuid).then((res)=>{
          let routeData = this.$router.resolve({
              name: "designModel",  params: {uuid: res.uuid}
          });
          window.open(routeData.href, "_blank");
      })
    },
    getGroup() {
      getDictionaryGroup({ parentCode: "MODEL_CATEGORIES" }).then((res) => {
        res.unshift({
          uuid: "",
          name: "全部",
        });

        this.screenList = res;
      });
    },
    getModelList() {
      // this.modelList = [];
      let param={};
      if(this.isLogin){
        param = {
          isLogin: 1,
          orderBy: this.printNews,
          order: this.order,
          modelName: this.modelName,
          status: "RELEASED",
          attribute: this.printNews2,
          typeFirstUuid:
                  this.printScreenIndex == 0
                          ? ""
                          : this.screenList[this.printScreenIndex].uuid,
          typeSecondUuid:
                  this.printScreenTwoIndex == 0
                          ? ""
                          : this.screenList2[this.printScreenTwoIndex].uuid,
          current: this.current,
        pageSize: this.pageSize,
        }
      }else{
        param = {
          isLogin: 0,
          orderBy: this.printNews,
          order: this.order,
          modelName: this.modelName,
          status: "RELEASED",
          attribute: this.printNews2,
          typeFirstUuid:
                  this.printScreenIndex == 0
                          ? ""
                          : this.screenList[this.printScreenIndex].uuid,
          typeSecondUuid:
                  this.printScreenTwoIndex == 0
                          ? ""
                          : this.screenList2[this.printScreenTwoIndex].uuid,
          current: this.current,
          pageSize: this.pageSize,
        }
      }
      queryModelList(param).then((res) => {
        if (res != null && res.list != null && res.list.length > 0) {
          res.list.map((item) => {
            item.time = getHumanDate(new Date(item.createDate).getTime(),true);
          });
          this.modelList = res.list;
          this.total = res.total;
          // console.log('333',res.list );
          if(this.modelList.length>0){
            this.showNoModel=false;
          }else{
            this.showNoModel=true;
          }
        } else {
          this.showNoModel=true;
          this.total = 0;
        }
      });

    },
    getBannerList() {
      let params = {
        groupCode: this.groupCode,
      };
      getBannerList(params).then((res) => {
        this.bannerList = res;
        this.imgLoad();
      });
    },
    imgLoad() {
      if (this.bannerList.length > 0) {
        this.$nextTick(function () {
          // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
          // this.imgHeight = (document.body.clientWidth * 1) / 4;
          this.imgHeightsetIn = setInterval(() => {
            if (this.imgHeight == 0) {
              this.imgHeight = this.$refs.image[0].height;
            } else {
              clearInterval(this.imgHeightsetIn);
            }
          }, 520);
        });
      }
    },
    getPrintScreen(i, name) {
      if (this.printScreenIndex == i) {
        this.classShow = !this.classShow;
      } else {
      // if (i === 0) {
      //   console.log('111', );
      //   this.screenList2 = [];
      // } else {
        getDictionaryItem({ groupCode: this.screenList[i].code }).then(
          (itemList) => {
            itemList.unshift({
              uuid: "",
              name: "全部",
            });
            this.screenList2 = itemList;
			      this.getPrintScreenTwo(0)
          }
        );
      // }
      this.classShow = true;
      }
      this.printScreenIndex = i;
      this.current=1;
      this.getModelList();
    },
    getPrintScreenTwo(i) {
      this.printScreenTwoIndex = i;
      this.current=1;
      this.getModelList();
    },
    getPrintNews(i) {
      this.printNews = i;
      // console.log(this.printNews)
       if(this.printNews=="NEW"&&this.getPrintNews1==0){
         this.order = 'ASC';
         this.getPrintNews1=1
      }else if(this.printNews=="NEW"&&this.getPrintNews1==1){
         this.order = 'DESC';
         this.getPrintNews1=0
      }else if(this.printNews=="HOT"&&this.getPrintNews6==0){
         this.order = 'ASC';
         this.getPrintNews6=1
      }
      else if(this.printNews=="HOT"&&this.getPrintNews6==1){
         this.order = 'DESC';
         this.getPrintNews6=0
      }else if(this.printNews=="COLLECTION"&&this.getPrintNews3==0){
         this.order = 'ASC';
         this.getPrintNews3=1
      }
      else if(this.printNews=="COLLECTION"&&this.getPrintNews3==1){
         this.order = 'DESC';
         this.getPrintNews3=0
      }else if(this.printNews=="LIKE"&&this.getPrintNews4==0){
         this.order = 'ASC';
         this.getPrintNews4=1
      }
      else if(this.printNews=="LIKE"&&this.getPrintNews4==1){
         this.order = 'DESC';
         this.getPrintNews4=0
      }else if(this.printNews=="DOWNLOAD"&&this.getPrintNews5==0){
         this.order = 'ASC';
         this.getPrintNews5=1
      }
      else if(this.printNews=="DOWNLOAD"&&this.getPrintNews5==1){
         this.order = 'DESC';
         this.getPrintNews5=0
      }

      this.getModelList();
    },
    getPrintNews2(i) {
      this.printNews2 = i;
      this.current=1;
      this.getModelList();
    },
    // 点击前往详情页
    getModelDetalis(i) {
      let routeData = this.$router.resolve({
        name: "modelDetails",
        query: {
          uuid: this.modelList[i].uuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    loadMore() { },
      liked(model) {
        if (this.isLogin) {
          if(this.$store.state.isUsermessage.uuid == model.creatorUuid){
            this.$message({
              type: "success",
              message: "不能收藏自己的模型！",
            });
            return ;
          }
          let params = {
              likeType: 'MODEL',
              serviceType: 'LIKE',
              designerUuid: model.uuid,
          };
          like(params).then((res) => {
              if(res && res.success){
                saveModelCollection(model.uuid).then((res) => {
                  this.getModelList();
                  if(this.like){
                    this.$message({
                      type: "success",
                      message: "收藏成功",
                    });
                  }else{
                    this.$message({
                      type: "success",
                      message: "取消收藏成功",
                    });
                  }

                });
              }
          });
      } else {
      this.$message({
        type: "success",
        message: "您需要先登录哦！",
      });
        this.$router.push('/login')
        }
      },
  },
};
</script>

<style scoped lang="less">
.uploadModelButton {
  position: absolute;
  top: -150px;
  left: 35px;
  color: #fff;
  z-index: 9;
  border-radius: 20px;
  background: transparent;
  padding: 5px 12px;
  cursor: pointer;
  border: 1px solid #fff;
  font-size: 14px;
}

.container {
  width: 1200px;
  margin: 0 auto;

  /deep/ .vue-waterfall {
	 overflow-y: unset;
    overflow-x: unset;
  }
}

.printTitle {
  font-size: 28px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 60px;
  margin-bottom: 15px;
}

/deep/ .el-card {
  border-radius: 0px !important;
  border: 1px solid #ebeef559;
}

.box-card {
  margin-bottom: 20px;
  position: relative;
  width: 224px;
  //   border-radius: 6px;

  .image {
    width: 100%;
    display: block;
  }

  .mdfree {
    position: absolute;
    top: 10px;
    left: 10px;
    opacity: 0.6;
    border: none;
    line-height: 20px;
    height: 20px;
    width: 40px;
    text-align: center;
    padding: 0;
    color: #157efb;
  }
}

.mdTitle {
  font-size: 16px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 10px;

  span.mdTime {
    font-size: 12px;
    float: right;
    margin-top: 5px;
    color: #808080 !important;
  }
}

.mdDetail {
  font-size: 12px;
  margin-top: 10px;
  color: #808080;
}

.mpNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: default;
  span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 12px;
    height: 50px;
    line-height: 50px;

  }

  span a {
    color: #808080;
    cursor: default;
  }

  span a:hover {
    color: rgba(21, 126, 251, 0.8);
  }
}

.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ebeef5;
  margin: 0 -21px -15px;
  padding: 10px 20px;

  /deep/ .el-button {
    color: #157efb;
    border-color: #157efb;
    padding: 6px 10px;
    font-size: 12px;
  }
}

.content {
  /deep/ .el-col-4 {
    width: 20%;
  }
}

.print_screen {
  background: #f9f9f9;
  padding-top: 30px;

  .print_screen_box {
    background: #fff;
    width: 1200px;
    margin: 0 auto;
    // flex-wrap: wrap;
    padding: 20px 20px 10px 0;
    box-sizing: border-box;

    .print_title {
      flex-shrink: 0;
    }

    .print_screen_boxP {
      display: flex;
      flex-wrap: wrap;

      p {
        cursor: pointer;
      }

      .screen_text {
        color: #157efb;
        background: #157efb;
        border-radius: 5px;
        margin-bottom: 10px;
        color: #fff;
        padding: 3px 15px;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .screen_text {
      color: #157efb;
      cursor: pointer;
      background: #157efb;
      border-radius: 5px;
      margin-bottom: 10px;
      color: #fff;
      padding: 3px 15px;
      font-size: 14px;
    }

    p {
      margin-bottom: 10px;
      margin-right: 0px;
      padding: 3px 14px;
      font-size: 14px;
    }

    .materDetailsT {
      // background: #157efb;
      color: #157efb;
      border-radius: 5px;
      padding: 3px 15px;
      margin-bottom: 10px;
    }
  }

  .print_screen_box:nth-last-child(1) {
    border-top: 1px solid #efefef;
  }
}

.print_news {
  width: 1200px;
  margin: 0 auto;
  background-color: #f7f7f7;
  justify-content: space-between;

  p {
    font-size: 14px;
    margin-right: 10px;
    border-radius: 3px;
    padding: 3px 9px;
    height: 30px;
    line-height: 25px;
    box-sizing: border-box;
  }

  .print_news1 {
    padding: 10px 0;
    flex-shrink: 0;
  }
}

.print_shai {
  font-size: 14px;

  p {
    background: #fff;
    padding: 3px 15px;
  }

  .print_newsP {
    margin-right: 30px;
    cursor: pointer;
    background: #fff;
    border-radius: 3px;
    padding: 3px 15px;
  }

  .print_newsPs {
    color: #fff;
    background: #157efb;
    border-radius: 5px;
    padding: 3px 15px;
  }
}

.print_sort {
  background: #157efb;
  color: #fff;
}

.print_sort2 {
  background: #fff;
  color: #157efb;
}

.print_input {
  width: 1200px;
  margin: 0 auto;
  text-align: right;
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;

  input {
    background: #fff;
    border: none;
    border-radius: 5px;
    width: 222px;
    height: 30px;
    padding-left: 10px;
  }

  input::-webkit-input-placeholder {
    color: rgb(191, 191, 191);
  }

  i {
    position: absolute;
    top: 25%;
    // transform: translate(0, -50%);
    color: rgb(191, 191, 191);
    right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/model/index.vue